import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { AuthService } from 'src/app/_services/auth.service';
import { LoginService } from 'src/app/_services/login.service';
import { PaymentService } from 'src/app/_services/payment.service';
import { DatePipe } from '@angular/common';
import * as countrycitystatejson from 'countrycitystatejson';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatSort, Sort } from '@angular/material/sort';
import * as XLSX from 'xlsx';
import { VendorService } from 'src/app/_services/vendor.service';
import { CommonService } from 'src/app/_services/common.service';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { AlertService } from 'src/app/_alert';

interface Country {
  shortName: string;
  name: string;
}

export interface ApiResponse {
  formattedSettleDate: any;
  numberOfOrders: any;
  settleAmount: any;
  settlementDetails?: SettlementDetails[] | MatTableDataSource<SettlementDetails>;
}

export interface SettlementDetails {
  lenderName: any,
  vendorId: any,
  borrower: any,
  loanNumber: any,
  propertyAddress: any,
  authPNREFCode: any,
  settlePNREFCode: any,
  settleDate: any,
  settleAmount: any
}

export interface RemittanceResponse {
  formattedRemittedDate: any,
  completionDate: any,
  numberOfOrders: any,
  refundAmount: any,
  actualSettlementAmount: any,
  remittance: any,
  remittedPayments?: RemittedPayments[] | MatTableDataSource<RemittedPayments>;
}


export interface RemittedPayments {
  loanNumber: any,
  borrower: any,
  propertyAddress: any,
  partyName: any,
  orderDate: any,
  remittanceDate: any,
  refundAmount: any,
  formattedActualSettlementAmount: any,
  formattedRemittanceAmount: any
}

@Component({
  selector: 'app-payment-transaction',
  templateUrl: './payment-transaction.component.html',
  styleUrls: ['./payment-transaction.component.css'],
  providers: [DatePipe],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
  ],
})
export class PaymentTransactionComponent implements OnInit {
  date = new Date();
  data: any;
  vendor: any;
  batchIndex: number = 0;
  batchSize: number = 5;
  vendorID;
  isPaymentLoader: boolean = false;
  isSettleLoading: boolean = false;
  isRemitLoader: boolean = false;
  searchResults: any[] = [];
  searchAdd: any[] = [];
  searchCardName: any[] = [];
  searchLoan: any[] = [];
  trackingNum: any[] = [];
  countries: Country[];
  states: any[];
  cities: string[];
  tableData: any[] = [];

  expandedRemit: RemittanceResponse | null;
  expandedElement: ApiResponse | null;
  apiData: ApiResponse[] = []
  apiResponse: ApiResponse[] = [];
  remitApiResponse: RemittanceResponse[] = [];
  remitData: RemittanceResponse[] = []
  settleDataSource: MatTableDataSource<ApiResponse>;
  remitDataSource: MatTableDataSource<RemittanceResponse>;
  public dataSource = new MatTableDataSource(this.tableData);
  options = {
    autoClose: true,
    keepAfterRouteChange: true,
  };

  //settlement
  @ViewChildren('innerTables') innerTables: QueryList<MatTable<SettlementDetails>>;
  @ViewChildren('innerSort') innerSort: QueryList<MatSort>;
  @ViewChild('outerSort', { static: true }) sort: MatSort;

  //settle inner grid
  @ViewChild('innerPaginator', { static: true }) innerPaginator: MatPaginator;

  //settle outer
  @ViewChild('branchPaginator', { static: true }) branchPaginator: MatPaginator;

  //remittance
  @ViewChildren('innerRemitTables') innerRemitTables: QueryList<MatTable<RemittedPayments>>;
  @ViewChildren('innerRemitSort') innerRemitSort: QueryList<MatSort>;
  @ViewChild('outerRemitsort', { static: true }) Remitsort: MatSort;

  //remit outer
  @ViewChild('remitPaginator', { static: true }) remitPaginator: MatPaginator

  //pay trans
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sortt: MatSort;

  private countryData = countrycitystatejson;
  firstDay = new Date(this.date.getFullYear(), this.date.getMonth(), 1);
  lastDay = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0);
  custId = this.authService.getRegistredUserDetails().customerId;

  constructor(public authService: AuthService,
    private alertService: AlertService,
    public loginService: LoginService,
    private _liveAnnouncer: LiveAnnouncer,
    public router: Router,
    public paymentService: PaymentService,
    private el: ElementRef,
    private cd: ChangeDetectorRef,
    public commonService: CommonService,
    private vendorService: VendorService,
    private datePipe: DatePipe) {
    this.searchField()
  }

  ngOnInit(): void {
    // this.onRemittanceSearch();
    this.vendorService.Allvendors('', '').subscribe((response) => {
      this.data = response.map(obj => obj.vendorId);
      this.vendor = response;
      console.log(this.data)
    })

    if (this.paymentTransactionForm.value.country) {
      this.states = this.getStatesByCountry(this.paymentTransactionForm.value.country);
      console.log(this.states)
      this.paymentTransactionForm.get('state').enable();
    }
    const cachedTableData = this.paymentService.getTableData();
    if (cachedTableData) {
      this.tableData = cachedTableData;
      this.dataSource.data = this.tableData;
    }
  }


  searchField() {
    //zipcode
    this.paymentTransactionForm.get('zipCode').valueChanges.pipe(
      debounceTime(300), // Delay between consecutive API calls
      distinctUntilChanged() // Only call API when the value changes
    ).subscribe((query: any) => {
      if (query.length >= 3) {
        this.paymentService.searchByZipCode(this.datePipe.transform(this.paymentTransactionForm.value.fromDate, 'MM-dd-yyyy'),
          this.datePipe.transform(this.paymentTransactionForm.value.toDate, 'MM-dd-yyyy'), query, this.vendorID, this.custId,).subscribe(
            (response: any) => {
              console.log(response);
              this.searchResults = response;
              //console.log(this.searchResults)
            },
            error => {
              console.log('Error:', error);
            }
          );
      } else {
        this.searchResults = [];
      }
    })

    //address
    this.paymentTransactionForm.get('address').valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe((query: any) => {
      if (query.length >= 3) {
        this.paymentService.searchByAdd(this.datePipe.transform(this.paymentTransactionForm.value.fromDate, 'MM-dd-yyyy'),
          this.datePipe.transform(this.paymentTransactionForm.value.toDate, 'MM-dd-yyyy'), query, this.vendorID, this.custId,).subscribe(
            (response: any) => {
              console.log(response);
              this.searchAdd = response;
              //console.log(this.searchResults)
            },
            error => {
              console.log('Error:', error);
            }
          );
      } else {
        this.searchAdd = [];
      }
    })

    //cardHolderName
    this.paymentTransactionForm.get('cardHolderName').valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe((query: any) => {
      // const lowerCaseQuery = query.toLowerCase();
      if (query.length >= 3) {
        this.paymentService.searchByCardName(this.datePipe.transform(this.paymentTransactionForm.value.fromDate, 'MM-dd-yyyy'),
          this.datePipe.transform(this.paymentTransactionForm.value.toDate, 'MM-dd-yyyy'), query, this.vendorID, this.custId,).subscribe(
            (response: any) => {
              console.log(response);
              this.searchCardName = response;
              //console.log(this.searchResults)
            },
            error => {
              console.log('Error:', error);
            }
          );
      } else {
        this.searchCardName = [];
      }
    })

    //loan num
    this.paymentTransactionForm.get('loan').valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe((query: any) => {
      if (query.length >= 3) {
        this.paymentService.searchByLoan(this.datePipe.transform(this.paymentTransactionForm.value.fromDate, 'MM-dd-yyyy'),
          this.datePipe.transform(this.paymentTransactionForm.value.toDate, 'MM-dd-yyyy'), query, this.vendorID, this.custId,).subscribe(
            (response: any) => {
              console.log(response);
              this.searchLoan = response;
              //console.log(this.searchResults)
            },
            error => {
              console.log('Error:', error);
            }
          );
      } else {
        this.searchLoan = [];
      }
    })

    //trackingNumber
    this.paymentTransactionForm.get('trackingNumber').valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe((query: any) => {
      if (query.length >= 3) {
        this.paymentService.searchByTrackingNum(this.datePipe.transform(this.paymentTransactionForm.value.fromDate, 'MM-dd-yyyy'),
          this.datePipe.transform(this.paymentTransactionForm.value.toDate, 'MM-dd-yyyy'), query, this.vendorID, this.custId,).subscribe(
            (response: any) => {
              console.log(response);
              this.trackingNum = response;
              //console.log(this.searchResults)
            },
            error => {
              console.log('Error:', error);
            }
          );
      } else {
        this.trackingNum = [];
      }
    })
  }

  onStateClick(event) {
    var state = event.value;
    console.log("statee", state);
    if (state) {
      this.cities = this.getCitiesByState(this.paymentTransactionForm.value.country, state);
      console.log(this.cities)
      this.paymentTransactionForm.get('city').enable();
    }
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sortt;
  }

  paymentTransactionForm: FormGroup = new FormGroup(
    {
      trackingNumber: new FormControl(''),
      //afsStatus: new FormControl(''),
      fromDate: new FormControl(this.firstDay),
      toDate: new FormControl(this.lastDay),
      cardNum: new FormControl(''),
      firstFour: new FormControl(''),
      lastFour: new FormControl(''),
      cardHolderName: new FormControl(''),
      serviceType: new FormControl('B'),
      address: new FormControl(''),
      state: new FormControl(''),
      zipCode: new FormControl(''),
      vendorId: new FormControl(''),
      loan: new FormControl(''),
      city: new FormControl(''),
      country: new FormControl('US'),
      paymentStatusId: new FormControl(-1),
      borrowerName: new FormControl('')
    }
  )

  paymentSettlementForm: FormGroup = new FormGroup({
    fromSettle: new FormControl(this.firstDay),
    toSettle: new FormControl(this.lastDay),
    showRefund: new FormControl(false)
  })

  paymentRemittanceForm: FormGroup = new FormGroup({
    fromRemit: new FormControl(this.firstDay),
    toRemit: new FormControl(this.lastDay),
    vendorRemit: new FormControl('ALLVENDORS'),
    lendorRemit: new FormControl(''),
    paymentStatusId: new FormControl(19),
    internalVendorId: new FormControl('')
  })

  displayedColumns: string[] = ['srNo', 'orderDate', 'trackingNumber', 'loanNumber', 'settleDate', 'cardHolderName', 'borrowerName', 'vendorName', 'settleAmount'];
  displayedSettleParentColumns: string[] = ['formattedSettleDate', 'numberOfOrders', 'settleAmount'];
  displayedSettleChildColumns: string[] = ['orderDate', 'loanNumber', 'formattedSettleDate', 'lenderName', 'borrower', 'vendorId', 'settleAmount'];
  displayedRemittanceParentColumns: string[] = ['formattedRemittedDate', 'completionDate', 'numberOfOrders', 'refundAmount', 'actualSettlementAmount', 'remittance'];
  displayedRemittanceChildColumns: string[] = ['loanNumber', 'borrower', 'propertyAddress', 'partyName', 'orderDate', 'remittanceDate', 'refundAmount', 'formattedActualSettlementAmount', 'formattedRemittanceAmount'];

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim();
    this.settleDataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    if (this.settleDataSource.paginator) {
      this.settleDataSource.paginator.firstPage();
    }
  }

  getCountries() {
    return this.countryData.getCountries();
  }

  getStatesByCountry(countryShotName: string) {
    return this.countryData.getStatesByShort(countryShotName);
  }

  getCitiesByState(country: any, state: any) {
    return this.countryData.getCities(country, state);
  }

  onPressff(event) {
    const inputValue = event.target.value;
    const maxDigits = 4;
    if (event.target.value.length > 4) {
      const truncatedValue = inputValue?.slice(0, maxDigits);
      event.target.value = truncatedValue;
      this.paymentTransactionForm.value.firstFour = event.target.value
    }
  }
  onPresslf(event) {
    const inputValue = event.target.value;
    const maxDigits = 4;
    if (event.target.value.length > 4) {
      const truncatedValue = inputValue?.slice(0, maxDigits);
      event.target.value = truncatedValue;
      this.paymentTransactionForm.value.lastFour = event.target.value
    }
  }


  //payment trans
  onSearch() {
    this.isPaymentLoader = true;
    this.paymentService.search(this.datePipe.transform(this.paymentTransactionForm.value.fromDate, 'MM-dd-yyyy'),
      this.datePipe.transform(this.paymentTransactionForm.value.toDate, 'MM-dd-yyyy'),
      this.paymentTransactionForm.value.paymentStatusId,
      this.custId,
      this.paymentTransactionForm.value.address,
      this.paymentTransactionForm.value.borrowerName,
      this.paymentTransactionForm.value.cardHolderName,
      this.paymentTransactionForm.value.firstFour,
      this.paymentTransactionForm.value.lastFour,
      this.paymentTransactionForm.value.city,
      this.paymentTransactionForm.value.loan,
      this.paymentTransactionForm.value.state,
      this.paymentTransactionForm.value.zipCode,
      this.paymentTransactionForm.value.vendorId,
      this.paymentTransactionForm.value.trackingNumber.trim(),
    ).subscribe
      ((response: any) => {
        console.log(response);
        this.tableData = response;
        this.dataSource.data = this.tableData;
        this.paymentService.setTableData(this.tableData);
        if (response.length == 0) {
          this.alertService.error("No data found", this.options);
        }
        this.isPaymentLoader = false;
      })
  }

  onReset() {
    this.paymentTransactionForm.reset({
      fromDate: this.paymentTransactionForm.get('fromDate').value,
      toDate: this.paymentTransactionForm.get('toDate').value,
      serviceType: this.paymentTransactionForm.get('serviceType').value,
    })
    setTimeout(() => {
      this.commonService.reloadComponent(true);
    }, 1000);
  }

  //settlement
  onSettlementSearch() {
    this.isSettleLoading = true;
    this.apiData = [];
    this.paymentService.searchSettlementList(this.datePipe.transform(this.paymentSettlementForm.value.fromSettle, 'MM-dd-yyyy'),
      this.datePipe.transform(this.paymentSettlementForm.value.toSettle, 'MM-dd-yyyy'),
      this.paymentSettlementForm.value.showRefund,
      this.custId).subscribe((response: any) => {
        console.log(response);
        this.apiResponse = response;
        if (response.length == 0) {
          this.alertService.error("No data found", this.options);
        }
        this.apiResponse.forEach((user) => {
          if (user.settlementDetails && Array.isArray(user.settlementDetails) && user.settlementDetails.length) {
            this.apiData = [...this.apiData, { ...user, settlementDetails: new MatTableDataSource(user.settlementDetails) }];
          } else {
            this.apiData = [...this.apiData, user];
          }
        });
        this.settleDataSource = new MatTableDataSource(this.apiData);
        this.settleDataSource.paginator = this.branchPaginator;
        this.settleDataSource.sort = this.sort;

        this.isSettleLoading = false;
      })
  }

  //toggle settle
  toggleRow(element: ApiResponse) {
    element.settlementDetails && (element.settlementDetails as MatTableDataSource<SettlementDetails>)
      .data.length ? (this.expandedElement = this.expandedElement === element ? null : element) : null;
    this.cd.detectChanges();
    this.innerTables.forEach((table, index) => (table.dataSource as MatTableDataSource<SettlementDetails>).sort = this.innerSort.toArray()[index]);
  }

  //toggle remit
  toggleRemitRow(element: RemittanceResponse) {
    element.remittedPayments && (element.remittedPayments as MatTableDataSource<RemittedPayments>)
      .data.length ? (this.expandedRemit = this.expandedRemit === element ? null : element) : null;
    this.cd.detectChanges();
    this.innerRemitTables.forEach((table, index) => (table.dataSource as MatTableDataSource<RemittedPayments>).sort = this.innerRemitSort.toArray()[index]);
  }

  applyFilter1(filterValue: string) {
    this.innerTables.forEach(
      (table, index) =>
      ((table.dataSource as MatTableDataSource<SettlementDetails>).filter = filterValue
        .trim()
        .toLowerCase())
    );
  }

  applyRemitFilter(filterValue: string) {
    this.innerRemitTables.forEach(
      (table, index) =>
      ((table.dataSource as MatTableDataSource<RemittedPayments>).filter = filterValue
        .trim()
        .toLowerCase())
    );
  }

  onRemittanceSearch() {
    this.isRemitLoader = true;
    const custId = "589f3998-6efc-4968-bebc-79d5ea8f1f68"
    this.remitData = [];
    this.paymentService.searchRemittance(this.datePipe.transform(this.paymentRemittanceForm.value.fromRemit, 'MM-dd-yyyy'),
      this.datePipe.transform(this.paymentRemittanceForm.value.toRemit, 'MM-dd-yyyy'),
      this.paymentRemittanceForm.value.paymentStatusId,
      this.paymentRemittanceForm.value.vendorRemit,
      this.custId,
      //custId,
      this.paymentRemittanceForm.value.internalVendorId,
      this.paymentRemittanceForm.value.lendorRemit
    ).subscribe((response: any) => {
      console.log(response);
      this.remitApiResponse = response;
      if (response.length == 0) {
        this.alertService.error("No data found", this.options);
      }
      this.remitApiResponse.forEach((user) => {
        if (user.remittedPayments['pagedPaymentByLender'] && Array.isArray(user.remittedPayments['pagedPaymentByLender']) && user.remittedPayments['pagedPaymentByLender'].length) {
          this.remitData = [...this.remitData, { ...user, remittedPayments: new MatTableDataSource(user.remittedPayments['pagedPaymentByLender']) }];
        } else {
          this.remitData = [...this.remitData, user];
        }
        // console.log(user.remittedPayments['pagedPaymentByLender'])
      });
      this.remitDataSource = new MatTableDataSource(this.remitData);
      this.remitDataSource.paginator = this.remitPaginator;
      this.remitDataSource.sort = this.Remitsort;
      this.isRemitLoader = false
    })
  }

  //download payment
  exportToExcel(): void {
    const dataToExport = this.dataSource.data.map(item => ({
      'Order Date': item.orderDate,
      'Tracking Number': item.trackingNumber,
      'Loan Number': item.loanNumber,
      'Settle Date': item.settleDate,
      'Card Holder Name': item.cardHolderName,
      'Borrower Name': item.borrowerName,
      'Vendor Name': item.vendorId,
      'Settle Amount': item.settleAmount
    }));

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Table Data');
    XLSX.writeFile(wb, 'payment report.xlsx');
  }

  //download remittance
  downloadRemitExcel() {
    const dataToExport = this.remitDataSource.data.map(item => ({
      'Remit Date': item.formattedRemittedDate,
      'Completion Date': item.completionDate,
      '# of Orders': item.numberOfOrders,
      'Refund Amount': item.refundAmount,
      'Settle Amount': item.actualSettlementAmount,
      'Remittance': item.remittance
    }));
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Table Data');
    XLSX.writeFile(wb, 'remit payment summary report.xlsx');
  }

  //download settle
  downloadSettleExcel() {
    const dataToExport = this.settleDataSource.data.map(item => ({
      'Settle Date': item.formattedSettleDate,
      '# of Orders': item.numberOfOrders,
      'Settle Amount': item.settleAmount
    }));
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Table Data');
    XLSX.writeFile(wb, 'settlement summary report.xlsx');
  }

  //download inner settle
  downloadInnerSettleExcel(data: any) {
    const dataToExport = data.map(item => ({
      'Order Date': item.orderDate,
      'Loan Number': item.loanNumber,
      'Settle Date': item.formattedSettleDate,
      'Lender Name': item.lenderName,
      'Borrower Name': item.borrower,
      'Vendor Name': item.vendorId,
      'Settle Amount': item.settleAmount
    }));
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'NestedTableData');
    XLSX.writeFile(wb, 'settlement summary report.xlsx');
  }

  //download inner remit
  downloadInnerRemitExcel(data: any) {
    const dataToExport = data.map(item => ({
      'Loan Number': item.loanNumber,
      'Borrower Name': item.borrower,
      'Property Address': item.propertyAddress,
      'Lender Name': item.partyName,
      'Order Date': item.orderDate,
      'Remit Date': item.remittanceDate,
      'Refund Amount': item.refundAmount,
      'Settle Amount': item.formattedActualSettlementAmount,
      'Remit Amount': item.formattedRemittanceAmount
    }));
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'NestedTableData');
    XLSX.writeFile(wb, 'remittance summary report.xlsx');
  }

  announceSortChange(sortState: Sort) {
    console.log('fired vendor');
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }
}



